// ── Câu hỏi nhanh theo ROLE (shared giữa floating chatbot và full page) ──
const ROLE_SUGGESTIONS = {
  SUPER_ADMIN: {
    label: 'Quản trị hệ thống', color: '#6d5ae0',
    questions: [
      { q: 'RAW mode realtime: phân tích toàn bộ dữ liệu hệ thống và trả lời theo dữ liệu mới nhất.', label: 'RAW realtime + AI', icon: 'fa-database' },
      { q: 'Tổng quan toàn hệ thống?',        label: 'Tổng quan hệ thống',  icon: 'fa-server' },
      { q: 'Hợp đồng nào sắp hết hạn?',       label: 'HĐ sắp hết hạn',      icon: 'fa-file-contract' },
      { q: 'Phân tích quỹ lương tháng này?',   label: 'Quỹ lương',           icon: 'fa-money-bill-wave' },
      { q: 'Tình hình tuyển dụng hiện tại?',   label: 'Tuyển dụng',          icon: 'fa-user-plus' },
      { q: 'Tài sản nào cần bảo trì?',         label: 'Tài sản bảo trì',     icon: 'fa-tools' },
      { q: 'Xe và bảo hiểm sắp hết hạn?',     label: 'Xe sắp hết hạn',      icon: 'fa-car' },
      { q: 'Nhân viên đi muộn nhiều nhất?',    label: 'Đi muộn nhiều nhất',  icon: 'fa-clock' },
      { q: 'Rủi ro nhân sự cần xử lý?',       label: 'Rủi ro nhân sự',      icon: 'fa-exclamation-triangle' },
    ]
  },
  ADMIN: {
    label: 'Quản trị viên', color: '#2f6bd8',
    questions: [
      { q: 'Tổng quan toàn hệ thống?',        label: 'Tổng quan hệ thống',  icon: 'fa-server' },
      { q: 'Hợp đồng nào sắp hết hạn?',       label: 'HĐ sắp hết hạn',      icon: 'fa-file-contract' },
      { q: 'Phân tích quỹ lương tháng này?',   label: 'Quỹ lương',           icon: 'fa-money-bill-wave' },
      { q: 'Tình hình tuyển dụng hiện tại?',   label: 'Tuyển dụng',          icon: 'fa-user-plus' },
      { q: 'Tài sản nào cần bảo trì?',         label: 'Tài sản bảo trì',     icon: 'fa-tools' },
      { q: 'Xe và bảo hiểm sắp hết hạn?',     label: 'Xe sắp hết hạn',      icon: 'fa-car' },
      { q: 'Nhân viên đi muộn nhiều nhất?',    label: 'Đi muộn nhiều nhất',  icon: 'fa-clock' },
      { q: 'Rủi ro nhân sự cần xử lý?',       label: 'Rủi ro nhân sự',      icon: 'fa-exclamation-triangle' },
    ]
  },
  LEVEL_II_MANAGER: {
    label: 'Quản lý cấp II', color: '#2894ae',
    questions: [
      { q: 'Tổng quan nhân sự công ty?',        label: 'Tổng quan nhân sự',   icon: 'fa-chart-pie' },
      { q: 'Hợp đồng nào sắp hết hạn?',         label: 'HĐ sắp hết hạn',      icon: 'fa-file-contract' },
      { q: 'Kết quả đánh giá KPI nhân viên?',   label: 'Kết quả KPI',         icon: 'fa-star' },
      { q: 'Tình hình nghỉ phép tháng này?',    label: 'Nghỉ phép tháng này', icon: 'fa-calendar-minus' },
      { q: 'Báo cáo công việc tháng này?',      label: 'Báo cáo công việc',   icon: 'fa-file-alt' },
      { q: 'Nhân viên đi muộn nhiều nhất?',     label: 'Đi muộn nhiều nhất',  icon: 'fa-clock' },
      { q: 'Tình hình tuyển dụng?',             label: 'Tuyển dụng',          icon: 'fa-user-plus' },
      { q: 'Hồ sơ nhân sự nào chưa đầy đủ?',   label: 'Hồ sơ chưa đầy đủ',  icon: 'fa-id-card' },
    ]
  },
  LEVEL_I_MANAGER: {
    label: 'Quản lý cấp I', color: '#136c34',
    questions: [
      { q: 'Tình hình nhân sự phòng ban?',      label: 'Nhân sự phòng ban',   icon: 'fa-sitemap' },
      { q: 'Báo cáo công việc tháng này?',      label: 'Báo cáo công việc',   icon: 'fa-file-alt' },
      { q: 'Nhiệm vụ nào đang quá hạn?',        label: 'Nhiệm vụ quá hạn',   icon: 'fa-exclamation-circle' },
      { q: 'Đơn nghỉ phép đang chờ duyệt?',     label: 'Chờ duyệt phép',     icon: 'fa-calendar-check' },
      { q: 'Kết quả đánh giá nhân viên?',       label: 'Đánh giá NV',        icon: 'fa-star' },
      { q: 'Chấm công tháng này thế nào?',      label: 'Chấm công tháng này',icon: 'fa-clock' },
      { q: 'Kế hoạch công việc hiện tại?',      label: 'Kế hoạch CV',        icon: 'fa-tasks' },
      { q: 'Tuyển dụng đang mở vị trí nào?',   label: 'Tuyển dụng mở',      icon: 'fa-user-plus' },
    ]
  },
  REPORT_MANAGER: {
    label: 'Quản lý báo cáo', color: '#b45309',
    questions: [
      { q: 'Báo cáo công việc tháng này?',      label: 'Báo cáo tháng này',  icon: 'fa-file-alt' },
      { q: 'Nhiệm vụ nào đang quá hạn?',        label: 'Nhiệm vụ quá hạn',  icon: 'fa-exclamation-circle' },
      { q: 'Tiến độ hoàn thành công việc?',     label: 'Tiến độ công việc',  icon: 'fa-tasks' },
      { q: 'Kế hoạch công việc hiện tại?',      label: 'Kế hoạch CV',        icon: 'fa-project-diagram' },
      { q: 'Đánh giá nhân viên tháng này?',     label: 'Đánh giá NV',        icon: 'fa-star' },
      { q: 'Tổng quan nhân sự công ty?',        label: 'Tổng quan nhân sự',  icon: 'fa-users' },
      { q: 'Thông báo mới nhất?',               label: 'Thông báo mới',      icon: 'fa-bell' },
      { q: 'Tình hình nghỉ phép tháng này?',   label: 'Nghỉ phép tháng này',icon: 'fa-calendar-minus' },
    ]
  },
  ACCOUNTANT: {
    label: 'Kế toán', color: '#be2d6a',
    questions: [
      { q: 'Tổng quỹ lương tháng này?',         label: 'Quỹ lương tháng này',icon: 'fa-money-bill-wave' },
      { q: 'Chi tiết phúc lợi nhân viên?',      label: 'Phúc lợi NV',        icon: 'fa-gift' },
      { q: 'Hợp đồng lao động đang hiệu lực?',  label: 'HĐ đang hiệu lực',   icon: 'fa-file-contract' },
      { q: 'Số dư phép năm nay của nhân viên?', label: 'Số dư phép',         icon: 'fa-calendar-alt' },
      { q: 'Nhân viên nào có lương cao nhất?',  label: 'Lương cao nhất',      icon: 'fa-trophy' },
      { q: 'Chi phí đào tạo năm nay?',          label: 'Chi phí đào tạo',     icon: 'fa-graduation-cap' },
      { q: 'Hợp đồng nào sắp hết hạn?',        label: 'HĐ sắp hết hạn',      icon: 'fa-exclamation-triangle' },
      { q: 'Tổng quan nhân sự công ty?',        label: 'Tổng quan nhân sự',   icon: 'fa-users' },
    ]
  },
  EMPLOYEE: {
    label: 'Nhân viên', color: '#4b5563',
    questions: [
      { q: 'Chấm công của tôi tháng này?',        label: 'Chấm công của tôi',  icon: 'fa-fingerprint' },
      { q: 'Số ngày phép còn lại của tôi?',       label: 'Phép còn lại',       icon: 'fa-umbrella-beach' },
      { q: 'Trạng thái đơn nghỉ phép của tôi?',   label: 'Đơn nghỉ phép',      icon: 'fa-calendar-check' },
      { q: 'Nhiệm vụ nào được giao cho tôi?',     label: 'Nhiệm vụ của tôi',   icon: 'fa-clipboard-list' },
      { q: 'Báo cáo công việc của tôi tháng này?',label: 'Báo cáo của tôi',    icon: 'fa-file-alt' },
      { q: 'Ca làm việc của tôi?',                label: 'Ca làm việc',         icon: 'fa-business-time' },
      { q: 'Thông báo mới nhất từ công ty?',      label: 'Thông báo mới',       icon: 'fa-bell' },
      { q: 'Tôi có nhiệm vụ nào quá hạn không?',  label: 'Nhiệm vụ quá hạn',  icon: 'fa-exclamation-circle' },
    ]
  },
};

export default ROLE_SUGGESTIONS;
